import { AbstractState } from '@sancare/typescript-commons/src/store/types'

import { ConditionGroup } from '@/store/modules/searches/types'

export enum ConditionOperatorEnum {
  AND = 'ET',
  OR = 'OU',
}

export enum GroupSearchOpEnum {
  ANDOR = 'andOr',
  ORAND = 'orAnd',
}

export type AutomationGroup = {
  id: number
  name: string
  actions: AutomationAction[]
  automated: boolean
  type: AutomationTypeEnum
  searchOperators: GroupSearchOpEnum
  globalCriteriaGroup: ConditionGroup
  criteriaGroups: ConditionGroup[]
  absentGhmList: string[]
  presentGhmList: string[]
  alertNoCro: boolean
  alertNoCrh: boolean
  waitForAnesthesia: boolean
  fulfillAnapathRequests: boolean
  waitDuration: number
  previousStayMaxDays: number
}

export enum AutomationTypeEnum {
  AI = 'ai',
  RULES = 'rules',
}

export enum AutomationModeEnum {
  WAITING = 'waiting',
  EXPIRED = 'expired',
  AUTOMATABLE = 'automatable',
}

export enum AutomationActionEnum {
  ADD_DP = 'add_dp',
  ADD_DR = 'add_dr',
  ADD_DAS = 'add_das',
  COPY_DP = 'copy_dp',
  COPY_DR = 'copy_dr',
  COPY_DAS = 'copy_das',
}

export const actionLabels = {
  [AutomationActionEnum.ADD_DP]: 'Appliquer le DP',
  [AutomationActionEnum.ADD_DR]: 'Appliquer le DR',
  [AutomationActionEnum.ADD_DAS]: 'Appliquer un DAS',
  [AutomationActionEnum.COPY_DP]: 'Copier le DP du séjour précédent',
  [AutomationActionEnum.COPY_DR]: 'Copier le DR du séjour précédent',
  [AutomationActionEnum.COPY_DAS]: 'Copier les DAS du séjour précédent',
}

export type AutomationAction = {
  id?: number
  action: AutomationActionEnum
  value: string
}

// todo: to be completed
export class AutomationState extends AbstractState {
  editedAutomationGroup: AutomationGroup
  automationStayListParams: {
    currentPage: number
    pageSize: number
    showSeen: boolean
    showStatus: boolean
    order: string
    reverseOrder: boolean
    automationMode: string
    automationGroupId?: number
  }
  automationStayList: {
    items: []
    pageCount: number
    totalCount: number
  }
  getAutomationGroupRequest: { fetching: boolean, error: string, ok: boolean } // todo: use ApiRequest when https://team-git.sancare.net/dev/ui/-/merge_requests/2312 merged
}

export type AutomationGroupStat = {
  automatableCount: number
  automatedCount: number
  expiredCount: number
  id: number
  name: string
  totalCount: number
  waitingCount: number
}

export type GhmListType = 'presentGhmList' | 'absentGhmList'
